import React from 'react';
import { useBooking } from '../context/BookingContext';
import { CalendarIcon, CheckCircleIcon, HomeIcon } from 'lucide-react';
export const BookingConfirmation = () => {
  const {
    booking,
    resetBooking
  } = useBooking();
  return <div className="text-center" data-id="element-5">
      <div className="flex justify-center mb-4" data-id="element-6">
        <CheckCircleIcon className="w-16 h-16 text-amber-500" data-id="element-7" />
      </div>
      <h3 className="text-2xl font-serif font-medium text-amber-400 mb-2" data-id="element-8">
        Booking Confirmed!
      </h3>
      <p className="text-blue-100 mb-8" data-id="element-9">
        Thank you, {booking.customerName}. Your appointment has been
        successfully booked.
      </p>
      <div className="bg-blue-950 rounded-lg border border-blue-800 p-6 mb-8 max-w-md mx-auto" data-id="element-10">
        <h4 className="text-lg font-medium text-amber-300 mb-4" data-id="element-11">
          Appointment Details
        </h4>
        <div className="space-y-3 text-left" data-id="element-12">
          <div className="flex items-start gap-3" data-id="element-13">
            <CalendarIcon className="w-5 h-5 text-amber-400 mt-0.5" data-id="element-14" />
            <div data-id="element-15">
              <div className="font-medium text-amber-200" data-id="element-16">
                {booking.date?.toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </div>
              <div className="text-blue-300" data-id="element-17">{booking.time}</div>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-18">
            <div className="w-5 h-5 flex items-center justify-center" data-id="element-19">
              <div className="w-4 h-4 rounded-full bg-amber-500" data-id="element-20"></div>
            </div>
            <div data-id="element-21">
              <div className="font-medium text-amber-200" data-id="element-22">
                {booking.service?.name}
              </div>
              <div className="text-blue-300" data-id="element-23">
                {booking.service?.duration} minutes • ${booking.service?.price}
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-24">
            <div className="w-5 h-5 flex items-center justify-center" data-id="element-25">
              <div className="w-4 h-4 rounded-full bg-amber-500" data-id="element-26"></div>
            </div>
            <div data-id="element-27">
              <div className="font-medium text-amber-200" data-id="element-28">
                With {booking.stylist?.name}
              </div>
              <div className="text-blue-300" data-id="element-29">
                {booking.stylist?.specialization}
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-30">
            <HomeIcon className="w-5 h-5 text-amber-400 mt-0.5" data-id="element-31" />
            <div data-id="element-32">
              <div className="font-medium text-amber-200" data-id="element-33">
                {booking.branch?.name}
              </div>
              <div className="text-blue-300" data-id="element-34">{booking.branch?.address}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-blue-200 mb-6" data-id="element-35">
        We've sent a confirmation email to{' '}
        <span className="font-medium text-amber-300" data-id="element-36">
          {booking.customerEmail}
        </span>
        <br data-id="element-37" />
        You'll receive a reminder 24 hours before your appointment.
      </div>
      <button onClick={resetBooking} className="px-6 py-2 bg-amber-500 text-blue-950 rounded-md hover:bg-amber-400 transition-colors" data-id="element-38">
        Book Another Appointment
      </button>
    </div>;
};